module.exports = __webpack_public_path__ + "static/media/AccountAddressBook.9ea1d1e8.png";